/**
 * CROEvolution Sales Offer V1 - JavaScript
 * Countdown timer, sticky minibar, pricing tiers, gallery, tabs, add to cart
 */

(function() {
  'use strict';

  // Only run if our sections exist
  const sections = document.querySelectorAll('.croevolution-sales-offer-v1');
  if (!sections.length) return;

  // ============================================
  // COUNTDOWN TIMER
  // ============================================
  function initCountdown() {
    const countdownEls = document.querySelectorAll('[data-countdown]');
    
    countdownEls.forEach(function(el) {
      const hours = parseInt(el.dataset.countdownHours, 10) || 48;
      const storageKey = 'cro_sales_offer_countdown_end';
      
      let endTime = localStorage.getItem(storageKey);
      if (!endTime || parseInt(endTime, 10) < Date.now()) {
        endTime = Date.now() + (hours * 60 * 60 * 1000);
        localStorage.setItem(storageKey, endTime);
      } else {
        endTime = parseInt(endTime, 10);
      }

      const daysEl = el.querySelector('[data-countdown-days]');
      const hoursEl = el.querySelector('[data-countdown-hours]');
      const minutesEl = el.querySelector('[data-countdown-minutes]');
      const secondsEl = el.querySelector('[data-countdown-seconds]');

      function update() {
        const now = Date.now();
        let diff = endTime - now;

        if (diff <= 0) {
          // Reset countdown
          endTime = Date.now() + (hours * 60 * 60 * 1000);
          localStorage.setItem(storageKey, endTime);
          diff = endTime - now;
        }

        const days = Math.floor(diff / (1000 * 60 * 60 * 24));
        const hrs = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const mins = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
        const secs = Math.floor((diff % (1000 * 60)) / 1000);

        if (daysEl) daysEl.textContent = String(days).padStart(2, '0');
        if (hoursEl) hoursEl.textContent = String(hrs).padStart(2, '0');
        if (minutesEl) minutesEl.textContent = String(mins).padStart(2, '0');
        if (secondsEl) secondsEl.textContent = String(secs).padStart(2, '0');
      }

      update();
      setInterval(update, 1000);
    });
  }

  // ============================================
  // STICKY PRODUCT MINI-BAR
  // ============================================
  function initMinibar() {
    const minibar = document.querySelector('[data-minibar]');
    const hero = document.querySelector('#cro-hero');
    
    if (!minibar || !hero) return;

    function checkScroll() {
      const heroRect = hero.getBoundingClientRect();
      const heroBottom = heroRect.bottom;
      
      if (heroBottom < 100) {
        minibar.classList.add('is-visible');
      } else {
        minibar.classList.remove('is-visible');
      }
    }

    window.addEventListener('scroll', checkScroll, { passive: true });
    checkScroll();

    // Minibar CTA click - scroll to hero
    const minibarCta = minibar.querySelector('[data-minibar-cta]');
    if (minibarCta) {
      minibarCta.addEventListener('click', function(e) {
        e.preventDefault();
        hero.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }
  }

  // ============================================
  // PRODUCT GALLERY
  // ============================================
  function initGallery() {
    const galleries = document.querySelectorAll('[data-gallery]');
    
    galleries.forEach(function(gallery) {
      const mainImage = gallery.querySelector('[data-gallery-main]');
      const thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
      const prevBtn = gallery.querySelector('[data-gallery-prev]');
      const nextBtn = gallery.querySelector('[data-gallery-next]');
      
      if (!mainImage || thumbs.length === 0) return;

      let currentIndex = 0;
      const images = Array.from(thumbs).map(function(thumb) {
        return thumb.dataset.imageUrl;
      });

      function updateImage(index) {
        if (index < 0) index = images.length - 1;
        if (index >= images.length) index = 0;
        
        currentIndex = index;
        mainImage.src = images[currentIndex];
        
        thumbs.forEach(function(thumb, i) {
          thumb.classList.toggle('is-active', i === currentIndex);
        });
      }

      thumbs.forEach(function(thumb) {
        thumb.addEventListener('click', function() {
          const index = parseInt(thumb.dataset.galleryThumb, 10);
          updateImage(index);
        });
      });

      if (prevBtn) {
        prevBtn.addEventListener('click', function() {
          updateImage(currentIndex - 1);
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', function() {
          updateImage(currentIndex + 1);
        });
      }
    });
  }

  // ============================================
  // TABS
  // ============================================
  function initTabs() {
    const tabContainers = document.querySelectorAll('[data-tabs]');
    
    tabContainers.forEach(function(container) {
      const buttons = container.querySelectorAll('[data-tab-btn]');
      const panels = container.querySelectorAll('[data-tab-panel]');
      
      buttons.forEach(function(btn) {
        btn.addEventListener('click', function() {
          const tabId = btn.dataset.tabBtn;
          
          buttons.forEach(function(b) { b.classList.remove('is-active'); });
          panels.forEach(function(p) { p.classList.remove('is-active'); });
          
          btn.classList.add('is-active');
          const panel = container.querySelector('[data-tab-panel="' + tabId + '"]');
          if (panel) panel.classList.add('is-active');
        });
      });
    });
  }

  // ============================================
  // PRICING TIERS
  // ============================================
  function initPricingTiers() {
    const pricingContainers = document.querySelectorAll('[data-pricing]');
    
    pricingContainers.forEach(function(container) {
      const tiers = container.querySelectorAll('[data-tier]');
      
      // Get product data if available
      const productJsonEl = document.querySelector('[data-product-json]');
      let productData = null;
      if (productJsonEl) {
        try {
          productData = JSON.parse(productJsonEl.textContent);
        } catch (e) {
          console.error('Error parsing product JSON', e);
        }
      }

      tiers.forEach(function(tier) {
        tier.addEventListener('click', function() {
          tiers.forEach(function(t) { t.classList.remove('is-selected'); });
          tier.classList.add('is-selected');
          
          const quantity = parseInt(tier.dataset.tier, 10);
          const discount = parseInt(tier.dataset.discount, 10) || 0;
          
          // Update prices
          updatePriceDisplays(productData, quantity, discount);
        });
      });
    });
  }

  function updatePriceDisplays(productData, quantity, discount) {
    if (!productData) return;
    
    const basePrice = productData.price / 100;
    const comparePrice = productData.compare_at_price ? productData.compare_at_price / 100 : null;
    const discountedPrice = basePrice * (1 - discount / 100);
    const totalPrice = discountedPrice * quantity;
    
    // Update main CTA price
    const salePriceEls = document.querySelectorAll('[data-sale-price]');
    salePriceEls.forEach(function(el) {
      el.textContent = formatMoney(totalPrice);
    });
    
    // Update compare price
    if (comparePrice) {
      const comparePriceEls = document.querySelectorAll('[data-compare-price]');
      comparePriceEls.forEach(function(el) {
        el.textContent = formatMoney(comparePrice * quantity);
      });
    }
  }

  function formatMoney(cents) {
    // Simple USD formatting - adjust for your currency
    if (typeof cents === 'number') {
      return '$' + cents.toFixed(2);
    }
    return cents;
  }

  // ============================================
  // ADD TO CART / REDIRECT TO SELECTOR
  // ============================================
  function initAddToCart() {
    const addToCartBtns = document.querySelectorAll('[data-add-to-cart], [data-add-to-cart-mobile]');
    
    addToCartBtns.forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        
        // Check if this button should redirect to selector page
        const selectorUrl = btn.dataset.selectorUrl;
        if (selectorUrl) {
          // Get selected quantity from tier
          const selectedTier = document.querySelector('[data-tier].is-selected');
          const quantity = selectedTier ? parseInt(selectedTier.dataset.tier, 10) : 1;
          
          // Redirect to color selector page with quantity
          window.location.href = selectorUrl + quantity;
          return;
        }
        
        // Fallback: Original add to cart behavior
        // Get product data
        const productJsonEl = document.querySelector('[data-product-json]');
        if (!productJsonEl) {
          // No product selected - redirect to collections
          window.location.href = '/collections/all';
          return;
        }

        let productData;
        try {
          productData = JSON.parse(productJsonEl.textContent);
        } catch (err) {
          console.error('Error parsing product JSON', err);
          return;
        }

        // Get selected variant (first available for now)
        const variant = productData.variants[0];
        if (!variant) {
          console.error('No variant available');
          return;
        }

        // Get selected quantity from tier
        const selectedTier = document.querySelector('[data-tier].is-selected');
        const quantity = selectedTier ? parseInt(selectedTier.dataset.tier, 10) : 1;

        // Show loading state
        btn.disabled = true;
        const originalText = btn.innerHTML;
        btn.innerHTML = '<span>Adding...</span>';

        // Add to cart via AJAX
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            id: variant.id,
            quantity: quantity
          })
        })
        .then(function(response) {
          if (!response.ok) {
            throw new Error('Network response was not ok');
          }
          return response.json();
        })
        .then(function(data) {
          // Success - redirect to cart
          window.location.href = '/cart';
        })
        .catch(function(error) {
          console.error('Add to cart error:', error);
          btn.disabled = false;
          btn.innerHTML = originalText;
          alert('Sorry, there was an error adding to cart. Please try again.');
        });
      });
    });
  }

  // ============================================
  // MOBILE STICKY CTA VISIBILITY
  // ============================================
  function initMobileCta() {
    const mobileCta = document.querySelector('[data-mobile-cta]');
    const heroCtaBtn = document.querySelector('.cro-main-cta__btn');
    
    if (!mobileCta || !heroCtaBtn) return;

    function checkVisibility() {
      const heroCtaRect = heroCtaBtn.getBoundingClientRect();
      const windowHeight = window.innerHeight;
      
      // Show mobile CTA only when hero CTA is scrolled out of viewport (below screen)
      // The hero CTA is visible if its bottom is above the viewport bottom
      const heroCtaIsVisible = heroCtaRect.bottom > 0 && heroCtaRect.top < windowHeight;
      
      if (heroCtaIsVisible) {
        // Hero CTA is visible - hide mobile CTA
        mobileCta.classList.remove('is-visible');
        mobileCta.classList.add('is-hidden');
      } else {
        // Hero CTA is scrolled out of view - show mobile CTA
        mobileCta.classList.remove('is-hidden');
        mobileCta.classList.add('is-visible');
      }
    }

    window.addEventListener('scroll', checkVisibility, { passive: true });
    window.addEventListener('resize', checkVisibility, { passive: true });
    checkVisibility();
  }

  // ============================================
  // VIDEO REVIEW
  // ============================================
  function initVideoReview() {
    const videoContainers = document.querySelectorAll('.cro-video-review');
    
    videoContainers.forEach(function(container) {
      const muteBtn = container.querySelector('[data-mute-btn]');
      const playBtn = container.querySelector('[data-play-btn]');
      const video = container.querySelector('video');
      
      if (muteBtn && video) {
        // Update button text based on mute state
        function updateMuteBtn() {
          const isMuted = video.muted;
          muteBtn.innerHTML = isMuted 
            ? '<svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M16.5 12c0-1.77-1.02-3.29-2.5-4.03v2.21l2.45 2.45c.03-.2.05-.41.05-.63zm2.5 0c0 .94-.2 1.82-.54 2.64l1.51 1.51C20.63 14.91 21 13.5 21 12c0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71zM4.27 3L3 4.27 7.73 9H3v6h4l5 5v-6.73l4.25 4.25c-.67.52-1.42.93-2.25 1.18v2.06c1.38-.31 2.63-.95 3.69-1.81L19.73 21 21 19.73l-9-9L4.27 3zM12 4L9.91 6.09 12 8.18V4z"/></svg> Tap to unmute'
            : '<svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z"/></svg> Tap to mute';
        }
        
        muteBtn.addEventListener('click', function() {
          video.muted = !video.muted;
          updateMuteBtn();
        });
        
        updateMuteBtn();
      }
      
      // Play button for placeholder (when no video is uploaded)
      if (playBtn) {
        playBtn.addEventListener('click', function() {
          // This would need a video URL to actually play
          console.log('Video play clicked - upload a video in section settings');
        });
      }
    });
  }

  // ============================================
  // INITIALIZE
  // ============================================
  function init() {
    initCountdown();
    initMinibar();
    initGallery();
    initTabs();
    initPricingTiers();
    initAddToCart();
    initMobileCta();
    initVideoReview();
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
